
import Player from '@vimeo/player'

export default {
  name: 'vimeo-player',

  ui: {
    iframe: '[js-vimeo-player-iframe]',
    overlay: '[js-vimeo-player-overlay]',
  },

  events: [
    {
      on: 'click',
      target: 'overlay',
      handle () {
        this.ui.overlay.classList.add('is-hidden')
        this.player.play()
      },
    },
  ],

  componentDidMount () {
    this.player = new Player(this.ui.iframe, {
      id: this.props.id,
      width: 640,
    })
  },
}
